import React from 'react'
import noop from 'lib/function/noop'
import type { LuxKitModalBehaviourDispatchAction } from './LuxKitModalBehaviourState'
import type LuxKitModalBehaviourState from './LuxKitModalBehaviourState'
import { MODAL_BEHAVIOUR_INITIAL_STATE } from './LuxKitModalBehaviourState'

export const LuxKitModalBehaviourStateContext = React.createContext<LuxKitModalBehaviourState>(MODAL_BEHAVIOUR_INITIAL_STATE)
export const LuxKitModalBehaviourDispatchContext = React.createContext<React.Dispatch<LuxKitModalBehaviourDispatchAction>>(noop)
